import { styled } from '@mui/material/styles';
import { Mode } from './FileExplorerHelpers';
import ListIcon from '@/assets/list.svg?react';
import GridIcon from '@/assets/view-grid.svg?react';

const ModeSwitch = ({
  mode,
  onChange,
}: {
  mode: Mode;
  onChange: (v: Mode) => void;
}) => {
  return (
    <Root aria-label="File explorer mode switch">
      <SwitchButton
        isSelected={mode === 'list'}
        onClick={() => onChange('list')}
        isLeft
        aria-label="List view"
      >
        <ListIcon />
      </SwitchButton>
      <SwitchButton
        isSelected={mode === 'grid'}
        onClick={() => onChange('grid')}
        isLeft={false}
        aria-label="Grid view"
      >
        <GridIcon />
      </SwitchButton>
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: theme.radii.sm,
  border: `1px solid ${theme.palette.primary.main}`,
  height: 40,

  '> div:first-of-type': {
    borderRight: `1px solid ${theme.palette.primary.main}`,
  },
}));

const SwitchButton = styled('div')<{
  isSelected: boolean;
  isLeft: boolean;
}>(({ theme, isSelected, isLeft }) => ({
  width: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: isSelected ? theme.palette.red50 : theme.palette.white,
  borderTopLeftRadius: isLeft ? theme.radii.sm : 0,
  borderBottomLeftRadius: isLeft ? theme.radii.sm : 0,
  borderTopRightRadius: isLeft ? 0 : theme.radii.sm,
  borderBottomRightRadius: isLeft ? 0 : theme.radii.sm,
  cursor: 'pointer',
  transition: 'background 0.2s ease-in-out',
  path: {
    stroke: isSelected
      ? theme.palette.primary.main
      : theme.palette.grey600,
  },
}));

export default ModeSwitch;
